export default __webpack_public_path__ + "static/media/EC.ae28d58e.svg";